import { API } from '@apis/endPoints';
import { axiosService, checkError } from '@services';

export default async function getEnergyBalanceTotal(plant_id) {
  if(!plant_id) {
    throw new Error('Plant ID is required');
  }

  const res = await axiosService({
    method: 'post',
    data: {
      path: `/measurements/sets/EnergyBalance/Total?Date=Total&WithTotal=true`,
      plant_id: plant_id,
    },
    apiPath: `${API.PLANT_MANAGEMENT}`,
  });

  if (res?.codeHTTP === 200) {
    return res;
  } else {
    return checkError(res, getEnergyBalanceTotal, plant_id);
  }
}

// setPvGenerationTotal(res.data.result.total.pvGeneration);
